import { ICrudLocale } from '@app/i18n/interface';

export const PROVIDER_CALLS_LOCALE_ES: ICrudLocale = {
  PROVIDER_CALLS: {
    LABEL: { SINGULAR: 'Llamada a Hotelbeds', PLURAL: 'Llamadas a Hotelbeds' },
    TITLE: 'Llamadas a Hotelbeds',
    SUBTITLE:
      'Registro de lo que enviamos a Hotelbeds y de lo que responde, sin recortes. Sirve para revisar incidencias y para la certificación.',
    REFRESH: 'Actualizar',
    LIST_TITLE: 'Llamadas del día',
    LOADING: 'Cargando las llamadas…',
    FIELD: {
      AT: 'Hora (UTC)',
      OPERATION: 'Operación',
      STATUS: 'Estado',
      DURATION: 'Duración',
      SIZE: 'Tamaño',
      REQUEST: 'Petición',
      REFERENCES: 'Referencias',
    },
    OPERATION: {
      AVAILABILITY: 'Disponibilidad',
      CHECKRATE: 'Confirmación de tarifa',
      BOOKING: 'Reserva',
      BOOKING_DETAIL: 'Consulta de una reserva',
      BOOKING_LIST: 'Listado de reservas',
      CANCELLATION: 'Cancelación',
      STATUS: 'Estado del proveedor',
      OTHER: 'Otra',
    },
    ATTEMPT: 'intento {{n}}',
    NO_RESPONSE: 'Sin respuesta',
    FILTER: {
      DAY: 'Día (UTC)',
      DAY_PLACEHOLDER: 'dd/mm/aaaa',
      OPERATION: 'Operación',
      ALL: 'Todas las operaciones',
      ALL_WITH_STATUS: 'Todas, con las de estado',
      TEXT: 'Texto',
      TEXT_PLACEHOLDER: 'Referencia, código de hotel o error',
      SEARCH: 'Buscar',
      HELP: 'El texto se busca tal cual en lo enviado y lo recibido: un código de hotel, la referencia de la reserva (IBSOA-84) o un localizador de Hotelbeds. Las comprobaciones de estado del proveedor solo salen si eliges «Todas, con las de estado».',
    },
    COUNT: '{{total}} llamadas, las más recientes primero. Horas en UTC.',
    COUNT_TRUNCATED:
      'Se muestran las {{shown}} más recientes de {{total}}. Afina la búsqueda para ver las demás. Horas en UTC.',
    EMPTY: 'Ninguna llamada ese día con esos filtros.',
    FAILED: {
      TITLE: 'No se ha podido leer el registro',
      DESC: 'La consulta ha fallado. Vuelve a intentarlo; si sigue fallando, avisa al equipo técnico.',
    },
    BEFORE_RECORD: {
      TITLE: 'Ese día todavía no se guardaba nada',
      DESC: 'El registro de llamadas empezó el {{day}}. Antes no se guardaba ninguna.',
    },
    DETAIL: {
      TITLE: 'Llamada a Hotelbeds',
      BACK: 'Volver a las llamadas',
      REQUEST: 'Lo que enviamos',
      RESPONSE: 'Lo que respondió Hotelbeds',
      REQUEST_HEADERS: 'Cabeceras de la petición',
      REQUEST_BODY: 'Cuerpo de la petición',
      RESPONSE_HEADERS: 'Cabeceras de la respuesta',
      RESPONSE_BODY: 'Cuerpo de la respuesta',
      COPY: 'Copiar',
      COPY_REQUEST_HEADERS: 'Copiar las cabeceras de la petición',
      COPY_REQUEST_BODY: 'Copiar el cuerpo de la petición',
      COPY_RESPONSE_HEADERS: 'Copiar las cabeceras de la respuesta',
      COPY_RESPONSE_BODY: 'Copiar el cuerpo de la respuesta',
      COPIED: 'Copiado',
      COPY_FAILED: 'No se ha podido copiar',
      DOWNLOAD: 'Descargar',
      HIDDEN_VALUE: 'valor oculto',
      NO_HEADERS: 'Sin cabeceras.',
      NO_BODY: 'Sin contenido.',
      NO_RESPONSE: 'Hotelbeds no llegó a responder (tiempo agotado o error de red).',
      ERROR: 'Error',
      NOTE: 'Petición y respuesta completas, tal como se enviaron y se recibieron. Solo se ocultan los valores de Api-key y X-Signature. «Copiar» y «Descargar» dan el texto exacto del registro. Las llamadas de una reserva se conservan hasta 6 meses después de su fecha de entrada (como mínimo, un año); el resto, un año desde el día en que se hicieron.',
      NOT_FOUND: 'No se encuentra esa llamada',
      NOT_FOUND_DESC: 'Puede que el enlace esté mal o que la llamada ya se haya borrado: las de una reserva se conservan hasta 6 meses después de su fecha de entrada (como mínimo, un año) y el resto, un año.',
    },
    ORDER: {
      TITLE: 'Llamadas a Hotelbeds',
      SUBTITLE: 'La búsqueda de la que salió la tarifa, la confirmación del precio, la reserva, sus consultas y la cancelación. Horas en UTC.',
      LOAD: 'Ver las llamadas a Hotelbeds',
      EMPTY: 'No hay llamadas guardadas para esta reserva. Se conservan hasta 6 meses después de la fecha de entrada (como mínimo, un año).',
      EMPTY_SINCE: 'No hay llamadas guardadas para esta reserva. El registro empezó el {{day}}: una reserva anterior no tiene ninguna.',
    },
  },
};
